function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HEADER_SWITCHER_PRODUCT_CLICKED, HEADER_SWITCHER_PRODUCT_HOVERED } from "constants/bigbrain-event-types";
import { useRef, useEffect } from "react";
import { StyledProductsSwitcher } from "./products-switcher.scss";
import { MAIN_PRODUCTS, ADDITIONAL_PRODUCTS, AI_SOLUTIONS } from "./consts";
import PictureComponent from "/components/core/picture/picture-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { trackEvent } from "/services/bigbrain-service";
import classNames from "classnames";
import { LAST_ACCOUNT_SLUG } from "constants/cookies";
import { getCookie } from "services/cookies-service";
import { isExistingUserInHeader } from "services/monday-platform/existing-accounts-service";
const ProductsSwitcher = (props)=>{
    const { translate, setShowproductsSwithcer, showproductsSwithcer, persistantCookies, headerCatalogLinks } = props;
    const EXISTING_USER = "existing_user";
    const NEW_USER = "new_user";
    const isExistingUser = isExistingUserInHeader(persistantCookies);
    const lastAccountSlug = getCookie(LAST_ACCOUNT_SLUG);
    const ref = useRef();
    useEffect(()=>{
        const checkIfClickedOutside = (e)=>{
            if (ref.current && !ref.current.contains(e.target)) {
                if (showproductsSwithcer) {
                    setShowproductsSwithcer(false);
                }
            }
        };
        // React 18 fix: defer listener registration to next tick.
        // React 18 moved event delegation from document to root element, causing the
        // opening click to immediately trigger click-outside and close the switcher.
        const timeoutId = setTimeout(()=>{
            document.addEventListener("click", checkIfClickedOutside);
        }, 0);
        return ()=>{
            clearTimeout(timeoutId);
            document.removeEventListener("click", checkIfClickedOutside);
        };
    }, [
        showproductsSwithcer,
        setShowproductsSwithcer
    ]);
    const renderProduct = (product, openInDifferentTab)=>{
        const shouldShowEarlyAccessTag = product === null || product === void 0 ? void 0 : product.hasEarlyAccessTag;
        const platformDomain = process.env.NEXT_PUBLIC_AUTH_PLATFORM_DOMAIN || "monday.com";
        const href = isExistingUser && (product === null || product === void 0 ? void 0 : product.exitingAccountPath) ? `https://${lastAccountSlug}.${platformDomain}${product.exitingAccountPath}` : product === null || product === void 0 ? void 0 : product.miniSiteLink;
        const ProductContent = ()=>/*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "icon-wrapper",
                        children: /*#__PURE__*/ _jsx(PictureComponent, {
                            src: product === null || product === void 0 ? void 0 : product.iconLink,
                            alt: product === null || product === void 0 ? void 0 : product.name
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "product-name",
                        children: translate(product === null || product === void 0 ? void 0 : product.name)
                    }),
                    shouldShowEarlyAccessTag && /*#__PURE__*/ _jsx("span", {
                        className: "beta-tag",
                        children: translate("header.menuItem.earlyAccess")
                    })
                ]
            });
        const handleMouseEnter = ()=>{
            trackEvent(HEADER_SWITCHER_PRODUCT_HOVERED, {
                kind: product === null || product === void 0 ? void 0 : product.name,
                info1: isExistingUser ? EXISTING_USER : NEW_USER
            });
        };
        const handleClick = ()=>{
            trackEvent(HEADER_SWITCHER_PRODUCT_CLICKED, {
                kind: product === null || product === void 0 ? void 0 : product.name,
                info1: isExistingUser ? EXISTING_USER : NEW_USER
            });
        };
        return /*#__PURE__*/ _jsx("a", {
            href: href,
            className: "product",
            target: openInDifferentTab ? "_blank" : undefined,
            onClick: handleClick,
            onMouseEnter: handleMouseEnter,
            children: /*#__PURE__*/ _jsx(ProductContent, {})
        });
    };
    const localizeProduct = (linkObject)=>{
        var _headerCatalogLinks_linkObject_miniSiteLink;
        return _object_spread_props(_object_spread({}, linkObject), {
            miniSiteLink: (_headerCatalogLinks_linkObject_miniSiteLink = headerCatalogLinks === null || headerCatalogLinks === void 0 ? void 0 : headerCatalogLinks[linkObject.miniSiteLink]) !== null && _headerCatalogLinks_linkObject_miniSiteLink !== void 0 ? _headerCatalogLinks_linkObject_miniSiteLink : linkObject.miniSiteLink
        });
    };
    const localizedMainProducts = MAIN_PRODUCTS.map(localizeProduct);
    const localizedAiSolutions = AI_SOLUTIONS.map(localizeProduct);
    const localizedAdditionalProducts = ADDITIONAL_PRODUCTS.map(localizeProduct);
    return /*#__PURE__*/ _jsxs(StyledProductsSwitcher, {
        className: classNames("products-switcher", {
            "is-existing": isExistingUser
        }),
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "main-products-title-wrapper",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "main-product-title",
                    children: translate("header.productsSwitcher.exploreFeaturedProducts")
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "main-products-wrapper",
                children: localizedMainProducts.map((product, index)=>renderProduct(product, false))
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "bottom-section",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "separator-line"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "additional-products-title-wrapper",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "additional-products-title",
                            children: [
                                translate("header.productsSwitcher.exploreAiProducts"),
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "ai-products-wrapper",
                        children: localizedAiSolutions.map((product, index)=>renderProduct(product, true))
                    }),
                    !isExistingUser && /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "separator-line"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "additional-products-title-wrapper",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "additional-products-title",
                                    children: [
                                        translate("header.product.section.moreProducts"),
                                        " "
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "additional-products-wrapper",
                                children: localizedAdditionalProducts.map((product)=>renderProduct(product, true))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default withGenericConfig(ProductsSwitcher);
